<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="4">
            <div class="operator">
              <el-button size="mini" type="primary" @click="toSave()">添加</el-button>
              <el-button type="danger" v-has-permission-code-and="'003500400005'" size="mini"
                @click="batchRemove()">批量删除</el-button> <el-button type="success"
                v-has-permission-code-and="'003500400000'" size="mini" @click="batchPay()">批量发放</el-button>
            </div>
          </el-col>
          <el-col :span="3">
            <el-form-item label="月份">
              <el-select size="mini" v-model="searchParams.mth" @change="chgSelect(1)" placeholder="请选择">
                <el-option v-for="itm in mthes" :key="itm" :label="itm" :value="itm">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3"   v-has-permission-code-and="'003500400000'">
            <el-form-item label="员工">
              <el-select size="mini" v-model="searchParams.tid" @change="chgSelect()" placeholder="请选择">
                <el-option v-for="itm in usrs" :key="itm.id" :label="itm.name" :value="itm.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="报销名称">
              <el-input size="mini" placeholder="模糊搜索" v-model="searchParams.rname"></el-input>
            </el-form-item>
          </el-col>

          <el-collapse-transition>
            <div v-if="isShowMoreSearch">
              <!--隐藏区域-->
            </div>
          </el-collapse-transition>
          <el-col :span="9">
            <div class="search-btn">
              <el-button type="primary" size="mini" @click="list">搜索</el-button>
              <el-button size="mini" @click="clearSearchVal">清空</el-button>
              {{ msg }}
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="reimTime" label="报销日期" width="120px">
          <!-- 转换为日期格式显示 -->
          <template slot-scope="scope">
            {{ new Date(scope.row.reimTime).format("yyyy-MM-dd") }}
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="报销发起人" width="110px">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.userName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="报销名称"></el-table-column>
        <el-table-column label="审批人" width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.state !== 1">
              {{ scope.row.sper }}  
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="cost" label="金额" width="100px">
        </el-table-column>

        <el-table-column prop="appendix" label="报销子项" width="100px">
        </el-table-column>
        <!-- 状态回显：将状态转换为文字显示 -->
        <el-table-column prop="state" label="状态" width="160">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.state === 1" type="warning">待审批</el-tag>
            <el-tag size="mini" v-if="scope.row.state === 2">已通过<el-tag v-if="scope.row.sper" type="info" size="mini">  {{ new Date(scope.row.sptm).format("yyyy-MM-dd") }}</el-tag></el-tag>
            <el-tag size="mini" v-if="scope.row.state === 3" type="danger">已退回</el-tag>
            <el-tag size="mini" v-if="scope.row.state === 4" type="success">已发放<el-tag v-if="scope.row.sper" type="info" size="mini">  {{ new Date(scope.row.mdtm).format("yyyy-MM-dd") }}</el-tag></el-tag>
          </template>
        </el-table-column>

        <el-table-column label="审批意见">
          <template slot-scope="scope">
            <span v-if="scope.row.approveObject && scope.row.state !== 1">
              {{ scope.row.approveObject[scope.row.approveObject.length-1].spyj }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="350px">
          <template slot-scope="scope">
            <div class="dataTable-operator">

              <el-button size="mini" @click="toDetail(scope.$index, scope.row)">详情</el-button>
              <el-button size="mini" @click="toUpdate(scope.$index, scope.row)"
                v-if="scope.row.state == 1 || scope.row.state == 3">编辑</el-button>
              <el-button size="mini" type="warning" @click="toApprove(scope.$index, scope.row)"
                v-has-permission-code-and="'003500400000'" v-if="scope.row.state == 1">审批</el-button>
              <el-button size="mini" type="success" @click="toPay(scope.$index, scope.row)"
                v-has-permission-code-and="'003500400000'" v-if="scope.row.state == 2">发放</el-button>
              <el-button size="mini" type="danger" v-if="scope.row.state == 1 || scope.row.state == 3"
                v-has-permission-code-and="'003500400005'" @click="remove(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
    <approve ref="approve"></approve>
  </div>
</template>
<script>
import edit from "./edit.vue";
import approve from "./Approve.vue";
import api from "@/api/cw/reimburses.js";
export default {
  name: "reimburses",
  components: {
    edit,
    approve,
  },
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),

      mthes: [],//备选月份
      usrs: [],// 备选员工
      msg: "",
      sumVal: 0
    };
  },
  methods: {

    chgSelect(t) {

      delete this.searchParams.rname
      this.page.current = 1
      if (t == 1) {
        api.listUsrHasReimAtMth({ mth: this.searchParams.mth }, res => {
          this.usrs = res.data
          this.searchParams.tid = this.usrs[0].id
          this.list()
        })
      } else {
        this.list()
      }

    },
    //获取数据
    list() {
      this.listLoading = true;

      let params = this.$utils.merger(this.searchParams, this.page);
      api.list(params, (response) => {
        this.listData = response.data;
        // JSON.stringify(this.listData.records.approveObject)
        this.listLoading = false;
        // console.log(this.listData.records.length);

        //报销对象JSON转换
        for (let i = 0; i < this.listData.records.length; i++) {
          if (this.listData.records[i].approveObject) {
            this.listData.records[i].approveObject = JSON.parse(
              this.listData.records[i].approveObject
            );
          }
        }
      });
    },
    //去添加
    toSave() {
      this.$refs.edit.open({}, "添加", 2);
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
      };
      this.$refs.edit.open(editParameter, "编辑", 0);
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.edit.open(detailParameter, "详情", 1, true);
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let selectedIDs = []
      for (let i in this.selected) {
        let v = this.selected[i]
        if (v.state == 2 || v.state == 4) {
          this.$utils.msg.info("请选择未通过审批的行");
          return;
        }
        selectedIDs.push(v.id)
      }


      this.$utils.confirm.warning("提示", "确定批量删除吗？", () => {

        api.remove(
          {
            ids: selectedIDs
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //去审批
    toApprove(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.approve.open(detailParameter, "报销审批", 1, false);
    },
    //去发放
    toPay(inde, row) {
      this.$utils.confirm.warning("提示", "确定发放吗？", () => {
        api.pay(
          {
            id: row.id,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    }, batchPay() {

      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let selectedIDs = []
      for (let i in this.selected) {
        let v = this.selected[i]
        if (v.state != 2) {
          this.$utils.msg.info("请选择【已通过审批】的行");
          return;
        }
        selectedIDs.push(v.id)
      }
      this.$utils.confirm.warning("提示", "确定发放 " + selectedIDs.length + " 条报销吗？", () => {
        api.payAll(
          {
            ids: selectedIDs
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {

      this.msg = ""
      this.sumVal = 0
      //清空
      this.selected = [];

      for (let item of val) {
        this.selected.push(item);
      }

      if (this.selected.length > 0) {
        this.selected.forEach(v => {
          this.sumVal += (v.cost * 1)
        })

        this.msg = "合计：" + this.selected.length + " 次 " + this.sumVal.toFixed(2) + "  元"
      }



    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },


    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.list();
    },
  },
  mounted() {
    // 
    //加载月份
    api.listMthOneYear({}, res => {

      this.mthes = res.data.mths
      this.usrs = res.data.usrs

      if (this.mthes && this.mthes.length > 0) {
        this.searchParams.mth = this.mthes[0]
      }

      if (this.usrs && this.usrs.length > 0) {
        this.searchParams.tid = this.usrs[0].id
      }

      this.list();

    })
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>
